var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99998 0C4.02966 0 0 4.02949 0 8.99998C0 13.9705 4.02966 18 8.99998 18C13.9708 18 18 13.9705 18 8.99998C18 4.02949 13.9707 0 8.99998 0ZM7.34901 13.6231L3.38613 9.66038L4.70698 8.33953L7.34901 10.9814L13.293 5.03727L14.6138 6.35812L7.34901 13.6231Z",
    fill: "#EC4E1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckMark);
export default __webpack_public_path__ + "static/media/check_mark.6745a4bde2e4d188bfce0fc327e584f2.svg";
export { ForwardRef as ReactComponent };